import HomeApi from './home';
import joinCompanyApi from './joinCompany';
const $api = Object.assign({}, 
	HomeApi,
	joinCompanyApi
);



export default $api;


// WEBPACK FOOTER //
// ./src/service/index/index.js